import { create } from "zustand";

interface AgeVerificationStore {
  userDateOfBirthRequested: boolean;
  markUserDateOfBirthRequested: () => void;
  clearUserDateOfBirthRequested: () => void;
}

export const useAgeVerificationStore = create<AgeVerificationStore>()(
  (set) => ({
    userDateOfBirthRequested: false,

    markUserDateOfBirthRequested: () =>
      set({
        userDateOfBirthRequested: true,
      }),
    clearUserDateOfBirthRequested: () =>
      set({
        userDateOfBirthRequested: false,
      }),
  }),
);
